import { Component } from "@angular/core";

@Component({
  selector: "app-list-your-machines-support",
  templateUrl: "./list-your-machines-support.component.html",
  styleUrls: ["./list-your-machines-support.component.scss"],
})
export class ListYourMachinesSupportComponent {
  constructor() {}

  openChat() {
    window["HubSpotConversations"]?.widget?.open();
  }
}
